module.exports = __webpack_public_path__ + "static/review-3-96c596f990b10d74d334914b25bfa5f5.jpg";